import * as constants from '../constants';

const mutations = {
  [constants.CATALOG_PRODUCT_FETCH]: (state, product) => {
    state.product = product;
  },
  [constants.CATALOG_CATEGORY_FETCH]: (state, category) => {
    state.category = category;
  },
};

export default mutations;
